import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  IconModule,
  LoadingModule,
  NoDataAvailableModule,
  NoMatchingResultsModule,
  QuickSearchDropdownModule,
  UnexpectedErrorStatusModule,
  WindowProviderModule,
  SharedPipesModule,
} from '@grid-ui/common';
import { FeatureFlagModule } from '@grid-ui/feature-flag';
import { PermissionsModule } from '@grid-ui/permissions';
import { WhoAmIEffects } from '@grid-ui/whoami';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiServicesModule } from '../api-services';
import { TopSubscriptionCounterComponent } from '../country-risk/country-risk-analyse';
import { PreviewModeWatermarkComponent } from '../preview-mode-watermark/preview-mode-watermark.component';
import { PrivacySettingsModule } from '../privacy-settings';
import { GridSharedPipesModule } from '../shared-ui-components/shared-pipes/shared-pipes.module';
import { AppSideAreaLinksComponent } from './app-side-area';
import {
  AccountSettingsModalComponent,
  AccountSettingsModalService,
  AppTopAreaComponent,
  TopRightHelpMenuComponent,
  TopRouteBreadcrumbsComponent,
  TopUserMenuComponent,
} from './app-top-area';
import { RoutedErrorComponent } from './routed-error';
import { NavService, SvgService, TopBreadcrumbTrailService } from './services';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    NgbModalModule,
    NgbTooltipModule,
    ApiServicesModule.forRoot(),
    LoadingModule,
    GridSharedPipesModule,
    WindowProviderModule,
    UnexpectedErrorStatusModule,
    FeatureFlagModule,
    IconModule,
    PermissionsModule,
    QuickSearchDropdownModule,
    NoDataAvailableModule,
    NoMatchingResultsModule,
    PrivacySettingsModule,
    SharedPipesModule,
  ],
  declarations: [
    AccountSettingsModalComponent,
    AppTopAreaComponent,
    TopRouteBreadcrumbsComponent,
    AppSideAreaLinksComponent,
    TopUserMenuComponent,
    RoutedErrorComponent,
    TopRightHelpMenuComponent,
    PreviewModeWatermarkComponent,
    TopSubscriptionCounterComponent,
  ],
  exports: [AppSideAreaLinksComponent, AppTopAreaComponent, RoutedErrorComponent, PreviewModeWatermarkComponent],
  providers: [AccountSettingsModalService, TopBreadcrumbTrailService, NavService, SvgService, WhoAmIEffects],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
